export default __webpack_public_path__ + "static/media/galderma.5b85d544.jpg";